import { z } from 'zod';

import { PaymentId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

export const NachaMarkAsCancelledEvent = BaseLoanEvent.extend({
  type: z.literal('nachaMarkAsCancelled'),
  paymentId: PaymentId,
});
export type NachaMarkAsCancelledEvent = z.infer<typeof NachaMarkAsCancelledEvent>;
